// extracted by mini-css-extract-plugin
export default {"cls1":"a1Bme9j4u6MaiLbZf7UF","cls2":"ccxHRV3ejFu5DBpqOH6w a1Bme9j4u6MaiLbZf7UF"};